import type { NotificationAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter } from './converters'
import { apiNotificationsToNotifications, countNewNotifications } from './notification-converters'

export const NotificationAPI: NotificationAPIInterface = {
  listNotifications: (signal?: AbortSignal) => responseDataConverter(
    client.GET('/notifications', { signal }),
    apiNotificationsToNotifications
  ),

  seeNotifications: (type: 'share_album' | 'dm' | 'reaction', ids: string[]) => {
    // Mark notifications as read by their IDs (which are timestamps)
    if (type === 'reaction') {
      // For reactions, we don't have a direct endpoint, might need to handle differently
      return Promise.resolve({
        data: undefined,
        response: new Response()
      })
    }

    // For other types, use the mark as read endpoint
    return Promise.all(
      ids.map(id =>
        client.PATCH('/notifications/{notificationId}', {
          params: { path: { notificationId: id } }
        })
      )
    ).then(() => ({
      data: undefined,
      response: new Response()
    }))
  },

  countNewNotifications: (signal: AbortSignal) => responseDataConverter(
    client.GET('/notifications', {
      params: {
        query: {
          limit: 100,
          unread_only: true
        }
      },
      signal
    }),
    countNewNotifications
  )
}
